import React from "react";
import { useLocation } from "react-router-dom";

/**
 * LIKEKIND WELCOME MODAL — LOCKED COPY
 * 
 * ROUTING ENFORCEMENT:
 * - Only shows on LikeKind routes (/, /my-world, /browse, etc.)
 * - NEVER shows on SCUTA routes (/scuta, /scuta/*)
 * - No fallback, no shared copy with SCUTA
 * 
 * DO NOT EDIT THIS COPY — Founder-approved final version
 */

export default function FounderWelcomeModal({ open, onClose }) {
  const location = useLocation();
  
  // ROUTING ENFORCEMENT: Never show on SCUTA routes
  const isScutaRoute = location.pathname.startsWith('/scuta');
  
  if (!open || isScutaRoute) return null;

  return (
    <div
      className="fixed inset-0 z-[2000] flex flex-col"
      style={{ backgroundColor: 'var(--fy-background-primary)' }}
      role="dialog"
      aria-modal="true"
      aria-label="Welcome to LikeKind"
      data-testid="likekind-welcome-modal"
    >
      {/* X dismiss button - top right */}
      <div className="absolute top-4 right-4">
        <button
          onClick={onClose}
          aria-label="Close"
          data-testid="likekind-welcome-close-btn"
          className="h-10 w-10 rounded-full border flex items-center justify-center text-xl leading-none"
          style={{ 
            borderColor: 'var(--fy-border-subtle)', 
            backgroundColor: 'var(--fy-surface-card)',
            color: 'var(--fy-text-primary)'
          }}
        >
          ×
        </button>
      </div>

      {/* Scrollable content area */}
      <div className="flex-1 overflow-auto">
        <div className="max-w-xl mx-auto px-6 py-12">
          {/* TITLE — LOCKED */}
          <h1 
            className="text-2xl font-semibold text-center mb-8"
            style={{ color: 'var(--fy-text-primary)' }}
          >
            Welcome to LikeKind
          </h1>

          {/* BODY — UPDATED COPY */}
          <div 
            className="space-y-6 text-base leading-relaxed"
            style={{ color: 'var(--fy-text-primary)' }}
          >
            <p>
              LikeKind is a place for people who want to be present — with their communities, their interests, and their time.
            </p>
            
            <p>
              This isn't a feed designed to pull you in or push you around.
            </p>
            
            <p>
              It's a space to notice what's happening nearby, coordinate with others, and build things together — calmly and intentionally.
            </p>
            
            <p>
              Your <strong>Base Camp</strong> is your home base.
            </p>
            
            <p>
              It shows the groups you're part of, activities around you, and commitments you've made.
            </p>
            
            <p className="font-medium">
              Everything here is opt-in.
            </p>
            
            <p className="font-medium">
              Nothing is ranked or boosted.
            </p>
            
            <p>
              Start where you are.<br/>
              See what's happening.<br/>
              Join when it feels right.
            </p>
          </div>
        </div>
      </div>

      {/* Primary action button - bottom */}
      <div className="p-6 text-center">
        <button
          onClick={onClose}
          data-testid="likekind-welcome-enter-btn"
          className="px-8 py-3 rounded-full text-base font-medium"
          style={{ 
            backgroundColor: 'var(--fy-accent-positive)',
            color: 'var(--fy-background-primary)'
          }}
        >
          Enter Base Camp
        </button>
      </div>
    </div>
  );
}
